import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Bot, Maximize2, Plus } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { AssistantChat } from "@/components/assistant/AssistantChat";
import { useAssistantChat } from "@/hooks/useAssistantChat";

function DrawerBody({ onExpand }) {
  const chat = useAssistantChat();
  return (
    <>
      <div className="flex items-center gap-2 border-b bg-slate-900 px-4 py-3 text-white">
        <Bot className="h-5 w-5 text-orange-400" />
        <SheetTitle className="flex-1 font-display text-xl font-bold uppercase tracking-wide text-white">Assistant IA</SheetTitle>
        <SheetDescription className="sr-only">Assistant de gestion de stock</SheetDescription>
        <Button variant="ghost" className="h-10 w-10 p-0 text-slate-300 hover:bg-slate-800 hover:text-white" title="Nouvelle conversation" onClick={chat.reset} data-testid="assistant-drawer-new"><Plus className="h-4 w-4" /></Button>
        <Button variant="ghost" className="mr-8 h-10 w-10 p-0 text-slate-300 hover:bg-slate-800 hover:text-white" title="Plein écran" onClick={onExpand} data-testid="assistant-drawer-expand"><Maximize2 className="h-4 w-4" /></Button>
      </div>
      <div className="min-h-0 flex-1"><AssistantChat chat={chat} /></div>
    </>
  );
}

export function AssistantDrawer() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  if (pathname.startsWith("/assistant")) return null;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="assistant-fab" title="Assistant IA"
        className="fixed bottom-6 right-6 z-40 flex h-16 items-center gap-2 rounded-full bg-orange-500 px-5 font-semibold text-slate-950 shadow-lg transition-transform duration-150 hover:-translate-y-0.5 hover:bg-orange-400 sk-pulse">
        <Bot className="h-6 w-6" /><span className="hidden sm:inline">Assistant</span>
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="flex w-full flex-col gap-0 p-0 sm:max-w-[520px] [&>button]:text-white" data-testid="assistant-drawer">
          {open && <DrawerBody onExpand={() => { setOpen(false); navigate("/assistant"); }} />}
        </SheetContent>
      </Sheet>
    </>
  );
}
